interface Props {
  height?: number
}

const Divider = ({ height = 20 }: Props) => {
  return (
    <div style={{ height: `${height}px` }} />
  )
}

export default Divider
